/* eslint-disable camelcase */
export const TIKTOK_UTM_SOURCE = 'bytedanceglobal_int'

const TIKTOK_CONTENT_TYPE = 'product'

const TiktokEvent = {
  VIEW_CONTENT: 'ViewContent',
  ADD_TO_CART: 'AddToCart',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  PURCHASE: 'Purchase',
} as const

type TTiktokEvent = typeof TiktokEvent[keyof typeof TiktokEvent]

type TTiktokUser = {
  email?: string
  externalId: string
}

type TTiktokContentParams = {
  value: number
  currency: string
  contentId: string
  contentName?: string
  eventId: string
}

class TiktokPixelService {
  private isLoaded = false
  private user: TTiktokUser | null = null

  load({ pixelId, eventId }: { pixelId: string; eventId: string }): void {
    if (this.isLoaded) return

    window.ttq.load(pixelId)
    this.isLoaded = true
    this.identify()
    window.ttq.page({ event_id: eventId })
  }

  setUser(user: TTiktokUser): void {
    this.user = user
    this.identify()
  }

  trackViewContent(params: TTiktokContentParams): void {
    this.trackContentEvent(TiktokEvent.VIEW_CONTENT, params)
  }

  trackAddToCart(params: TTiktokContentParams): void {
    this.trackContentEvent(TiktokEvent.ADD_TO_CART, params)
  }

  trackInitiateCheckout(params: TTiktokContentParams): void {
    this.trackContentEvent(TiktokEvent.INITIATE_CHECKOUT, params)
  }

  trackPurchase(params: TTiktokContentParams): void {
    this.trackContentEvent(TiktokEvent.PURCHASE, params)
  }

  private identify(): void {
    if (!this.isLoaded || !this.user) return

    const { email, externalId } = this.user

    window.ttq.identify({
      external_id: externalId,
      ...(email && { email }),
    })
  }

  private trackContentEvent(
    eventName: TTiktokEvent,
    { value, currency, contentId, contentName, eventId }: TTiktokContentParams,
  ): void {
    if (!this.isLoaded) return

    window.ttq.track(eventName, {
      value,
      currency: currency.toUpperCase(),
      content_id: contentId,
      content_type: TIKTOK_CONTENT_TYPE,
      ...(contentName && { content_name: contentName }),
      event_id: eventId,
    })
  }
}

export const tiktokPixelService = new TiktokPixelService()
